/**
 * @typedef {LecturChatMessage__Noti|LecturChatMessage__User|LecturChatMessage__Peer} LectureChatMessage
 */

/**
 * @typedef LecturChatMessage__Noti
 * @property {'noti'}                                   type        유형
 * @property {string}                                   message     메시지
 * @property {string}                                   createdAt   생성일시
 */

/**
 * @typedef LecturChatMessage__User
 * @property {'user'}                                   type        유형
 * @property {string}                                   message     회원 메시지
 * @property {string}                                   createdAt   생성일시
 */
/**
 * @typedef LecturChatMessage__Peer
 * @property {'peer'}                                   type        유형
 * @property {string}                                   _user       회원 인덱스
 * @property {string}                                   name        회원 이름
 * @property {string}                                   username    회원 아이디
 * @property {string}                                   message     회원 메시지
 * @property {string}                                   createdAt   생성일시
 */

/**
 * @param {LectureChatMessage} message
 * @returns {LectureChatMessage}
 */

export function initLectureChatMessage(message = {}) {
    return { ...(message || {}) };
}

/**
 * @typedef LectureChatState
 * @property {import("socket.io-client").Socket|null}   socket      소켓
 * @property {number}                                   count       사용자수
 * @property {number}                                   height      영역높이
 * @property {boolean}                                  loading     로딩
 * @property {LectureChatMessage[]}                     messages    메시지
 * @property {array}                                    watchers    시청자
 */

/**
 * @param {LectureChatState} state
 * @returns {LectureChatState}
 */
export function initLectureChatState(state = {}) {
    return {
        ...(state || {}),
        count: state?.count || 0,
        height: state?.height || 0,
        loading: state?.loading || false,
        messages: [...(state?.messages || [])].map(initLectureChatMessage),
        watchers: [...(state?.watchers || [])],
    };
}
